type SummaryPreviewFrameProps = {
  html: string
  dimmed?: boolean
}

export default function SummaryPreviewFrame({ html, dimmed = false }: SummaryPreviewFrameProps) {
  return (
    <div className={`overflow-y-auto ${dimmed ? 'opacity-50' : ''}`}>
      <iframe
        sandbox=""
        title="Summary preview"
        srcDoc={html}
        className="aspect-[8.5/22] w-full min-h-[22in] border border-gray-200 bg-white"
      />
    </div>
  )
}
